import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
`;

export const Items = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  border-radius: 20px;
`;

export const Image = styled.img`
  flex: none;
  height: 100%;
  width: 100%;
  object-fit: contain;
  transition: 0.5s ease-in-out;
`;

export const IconWrapper = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: 0;
  outline: 0;

  svg {
    cursor: pointer;
  }
`;

export const XWrapper = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: 0;
  outline: 0;
  cursor: pointer;
  z-index: 1002;

  svg {
    cursor: pointer;
  }
`;
